export default "__VITE_ASSET__BgFGjYKK__"